import React, { useState, useEffect, useRef, useCallback } from "react";
import { useExamStatus } from "../ExamStatusContext";
import { useScoreTable } from "../ScoreContext";
import withResetOnNavigation from '../withResetOnNavigation';
import questions from "../QA/Test10_q_a";
import TestContainer from "../TestContainer";
import ZoomControls from "../ZoomControls";
import "../../../css/test10.css";
import "../../../css/examplequestion.css";

const Test10 = ({ onNext }) => {
  const { examStatus } = useExamStatus();
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [inputValues, setInputValues] = useState({});
  const [istest10Started, setIstest10Started] = useState(false);
  const [notification, setNotification] = useState("");
  const [isTimeUp, setIsTimeUp] = useState(false);
  const score10 = useRef(0);
  const scoreTable = useScoreTable();

  const testDuration = 180;

  const exampleQuestions = [
    {
      question: "春になると[　ア　]なり,花が[　イ　]ます。",
      choices: {
        wordA: ["1.寒く　", "2.暖かく　", "3.冷たく　", "4.暑く　"],
        wordB: ["1.枯れ　", "2.実り　", "3.行き　", "4.咲き　"]
      },
      answer: {
        answerA: 2,
        answerB: 4
      },
    },
  ];

  useEffect(() => {
    const test10Status = localStorage.getItem("test10Status");
    if (examStatus === "検査中" && test10Status === "started") {
      localStorage.setItem("test10Status", "notStarted");
    }
  }, [examStatus]);

  const gradeTest = useCallback(() => {
    let calculatedScore = 0;

    questions.forEach((question, index) => {
      const userAnswer1 = parseInt(inputValues[index]?.choice1, 10);
      const userAnswer2 = parseInt(inputValues[index]?.choice2, 10);
      if (question.answer.answerA === userAnswer1) calculatedScore += 1;
      if (question.answer.answerB === userAnswer2) calculatedScore += 1;
    });

    score10.current = calculatedScore;
    localStorage.setItem("score10", calculatedScore);

    const [gScore, vScore] = scoreTable.scoreTable10[String(calculatedScore)] || [0, 0];
    const currentGScore = parseInt(localStorage.getItem("G_score"), 10) || 0;
    const currentVScore = parseInt(localStorage.getItem("V_score"), 10) || 0;

    localStorage.setItem("G_score", currentGScore + gScore);
    localStorage.setItem("V_score", currentVScore + vScore);

    setNotification("検査を終了します！");
    setIsTimeUp(true);

    if (onNext) onNext(); // ← 最終検査終了後に次の処理（例: 結果ページへ）
  }, [inputValues, scoreTable.scoreTable10, onNext]);

  const handleStartTest = () => {
    setIstest10Started(true);
    localStorage.setItem("test10Status", "started");
  };

  const initialOptions = ["-", "1", "2", "3", "4"];

  const handleInputChange = (index, field, value) => {
    setInputValues((prevValues) => {
      const newValues = { ...prevValues };
      if (!newValues[index]) {
        newValues[index] = { choice1: "", choice2: "" };
      }
      newValues[index][field] = value;

      if (
        newValues[index].choice1 !== "" &&
        newValues[index].choice2 !== "" &&
        currentQuestionIndex === index
      ) {
        setCurrentQuestionIndex(index + 1);
      }

      return newValues;
    });
  };

  const getOptions = () => initialOptions;

  if (!istest10Started) {
    return (
      <div className="test10-container">
        <h1>検査8 - やり方の説明</h1>
        <p>
          各問題で[　ア　]は（ア）から、[　イ　]は（イ）からもっとも適切な言葉を選び出し
          意味の通る文章を完成させてください。
        </p>
        <h2>例題</h2>
        <div className="example-container">
          <div className="example-questions">
            {exampleQuestions.map((example, index) => (
              <div key={index} className="test10-question">
                <span className="test10-word">{example.question}</span>
                <span className="test10-word">（ア）{example.choices.wordA}</span>
                <span className="test10-word">（イ）{example.choices.wordB}</span>
                <p>
                  解答例: ア：{example.answer.answerA}　イ：{example.answer.answerB}
                </p>
              </div>
            ))}
          </div>
          <p>※正解の単語を入れると「春になると暖かくなり,花が咲きます。」となります。</p>
        </div>
        <button className="start-button" onClick={handleStartTest}>
          検査に進む
        </button>
      </div>
    );
  }

  const renderedQuestions = (
    <div className="test10-container">
      {questions.slice(0, currentQuestionIndex + 1).map((question, index) => (
        <div key={index} className="test10-question">
          <p>問題 {index + 1}</p>
          <span className="test10-word">{question.question}</span>
          <span className="test10-word">（ア）{question.choices.wordA}</span>
          <span className="test10-word">（イ）{question.choices.wordB}</span>
          <div className="test10-inputs">
            <label>
              ア：
              <select
                value={inputValues[index]?.choice1 || "-"}
                onChange={(e) =>
                  handleInputChange(index, "choice1", e.target.value)
                }
              >
                {getOptions().map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </label>
            <span>&emsp;</span>
            <label>
              イ：
              <select
                value={inputValues[index]?.choice2 || "-"}
                onChange={(e) =>
                  handleInputChange(index, "choice2", e.target.value)
                }
              >
                {getOptions().map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <ZoomControls>
      <TestContainer
        title="検査8"
        isTimeUp={isTimeUp}
        notification={notification}
        renderedQuestions={renderedQuestions}
        manageTimer={true}
        gradeTest={gradeTest}
        testDuration={testDuration}
      />
    </ZoomControls>
  );
};

export default withResetOnNavigation(Test10);
